export const KEYS = {
  BREEDING: 'breeding',
  CALENDAR: 'calendar',
  EVENTS: 'events',
  HERD_METRICS: 'herd_metrics',
  HERD_OVERVIEW: 'herd_overview',
  MAP: 'map',
  PASTURE: 'pasture',
  WEATHER: 'weather'
};

export const LAYOUT_FIELDS_FOR_COMPARING = ['x', 'y', 'w', 'h'];

export const LAYOUTS = {
  lg: [
    { w: 2, h: 2, x: 0, y: 0, i: KEYS.HERD_METRICS },
    { w: 2, h: 2, x: 2, y: 0, i: KEYS.HERD_OVERVIEW },
    { w: 2, h: 2, x: 4, y: 0, i: KEYS.PASTURE },
    { w: 2, h: 4, x: 6, y: 0, i: KEYS.WEATHER },
    { w: 4, h: 6, x: 0, y: 2, i: KEYS.MAP },
    { w: 2, h: 2, x: 4, y: 2, i: KEYS.BREEDING },
    { w: 2, h: 4, x: 6, y: 4, i: KEYS.CALENDAR },
    { w: 2, h: 4, x: 4, y: 4, i: KEYS.EVENTS }
  ],
  md: [
    { w: 2, h: 2, x: 0, y: 0, i: KEYS.HERD_METRICS },
    { w: 2, h: 2, x: 2, y: 0, i: KEYS.HERD_OVERVIEW },
    { w: 2, h: 2, x: 4, y: 0, i: KEYS.PASTURE },
    { w: 2, h: 4, x: 4, y: 2, i: KEYS.WEATHER },
    { w: 4, h: 6, x: 0, y: 2, i: KEYS.MAP },
    { w: 2, h: 2, x: 4, y: 6, i: KEYS.BREEDING },
    { w: 4, h: 4, x: 2, y: 8, i: KEYS.CALENDAR },
    { w: 2, h: 4, x: 0, y: 8, i: KEYS.EVENTS }
  ],
  sm: [
    { w: 2, h: 2, x: 0, y: 0, i: KEYS.HERD_METRICS },
    { w: 2, h: 2, x: 2, y: 0, i: KEYS.HERD_OVERVIEW },
    { w: 2, h: 2, x: 4, y: 0, i: KEYS.PASTURE },
    { w: 2, h: 4, x: 4, y: 2, i: KEYS.WEATHER },
    { w: 4, h: 6, x: 0, y: 2, i: KEYS.MAP },
    { w: 2, h: 2, x: 4, y: 6, i: KEYS.BREEDING },
    { w: 4, h: 4, x: 2, y: 8, i: KEYS.CALENDAR },
    { w: 2, h: 4, x: 0, y: 8, i: KEYS.EVENTS }
  ],
  xs: [
    { w: 2, h: 2, x: 0, y: 0, i: KEYS.HERD_METRICS },
    { w: 2, h: 2, x: 0, y: 2, i: KEYS.HERD_OVERVIEW },
    { w: 2, h: 2, x: 0, y: 4, i: KEYS.PASTURE },
    { w: 2, h: 4, x: 0, y: 12, i: KEYS.WEATHER },
    { w: 2, h: 6, x: 0, y: 6, i: KEYS.MAP },
    { w: 2, h: 2, x: 0, y: 16, i: KEYS.BREEDING },
    { w: 2, h: 4, x: 0, y: 22, i: KEYS.CALENDAR },
    { w: 2, h: 4, x: 0, y: 18, i: KEYS.EVENTS }
  ],
  xxs: [
    { w: 1, h: 2, x: 0, y: 0, i: KEYS.HERD_METRICS },
    { w: 1, h: 2, x: 0, y: 2, i: KEYS.HERD_OVERVIEW },
    { w: 1, h: 2, x: 0, y: 4, i: KEYS.PASTURE },
    { w: 1, h: 4, x: 0, y: 12, i: KEYS.WEATHER },
    { w: 1, h: 6, x: 0, y: 6, i: KEYS.MAP },
    { w: 1, h: 2, x: 0, y: 16, i: KEYS.BREEDING },
    { w: 1, h: 4, x: 0, y: 22, i: KEYS.CALENDAR },
    { w: 1, h: 4, x: 0, y: 18, i: KEYS.EVENTS }
  ]
};

export const BREAKPOINTS = { lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 };

export const COLS = { lg: 8, md: 6, sm: 6, xs: 2, xxs: 1 };

export const ROW_HEIGHT = 100;

export const HERD_METRICS = {
  activeLivestockCount: 'Livestock count',
  calvesProducedCount: 'Calves produced',
  calvesWeanedCount: 'Calves weaned'
};

export const HERD_OVERVIEW = {
  trackedLivestock: 'Tracked livestock',
  outOfBounds: 'Out of bounds',
  offlineDevices: 'Offline devices',
  lowBatteryNumber: 'Low Battery'
};

export const PASTURE = {
  haUnderGrazing: 'Ha Under Grazing',
  haResting: 'Ha Resting',
  stockingRate: 'Stocking rate',
  carryingCapacity: 'Carrying capacity'
};

export const BREEDING = {
  cowsPregnant: 'Cows pregnant',
  calvingDue: 'Calving due',
  weaningDue: 'Weaning due'
};

export const HEALTH = {
  lowActivityAlerts: 'Low activity alerts',
  highActivityAlerts: 'High activity alerts'
};

export const EVENTS = {
  treatments: 'Treatments',
  measures: 'Measures',
  sellSlaughter: 'Sell/Slaughter',
  groupMovement: 'Group movement',
  pregnancyChecks: 'Pregnancy checks',
  tasks: 'Tasks'
};
